export const blockIconsHardwareLiveTvNew = (
	<span className='material-symbols-outlined'>live_tv</span>
);
